/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLaptopSlash: {
  name: 'laptop-slash';
  data: string;
} = {
  name: 'laptop-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.707 3.293a1 1 0 0 0-1.414 1.414l16 16a1 1 0 0 0 1.414-1.414l-16-16ZM7 4a1 1 0 0 1 1-1h11a2 2 0 0 1 2 2v10a1 1 0 1 1-2 0V5H8a1 1 0 0 1-1-1ZM3 15V8a1 1 0 0 1 2 0v7h7a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2Zm-1 5a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
